export const profile = {
  LAST_NAME: "TEST",
  FIRST_NAME: "AGENT001",
  PROXY_GUID: "291347F3DF4D7AD2E063F38A4C0AA9C5",
  HUB_ROLE:"Producers",
  ROLE:"Individual Life Agent"
}
